export function initYaMap($block, mapCenter, placemarks) {
    const thisMapId = $block.attr('id');

    ymaps.ready(initMap);

    function initMap() {
        const map = new ymaps.Map(thisMapId, {
            center: mapCenter,
            controls: ['geolocationControl', 'zoomControl'],
            size: 'small',
            zoom: 15,
        }, {
        });

        addPlacemarks(map);
    }

    function addPlacemarks(map) {
        $.each(placemarks, function(i, item) {
            const placemark = initPlacemark(item);
            map.geoObjects.add(placemark);
        });
    }

    function initPlacemark(item) {
        return new ymaps.Placemark([item.x, item.y], {}, {
            iconLayout: 'default#image',
            iconImageHref: item.iconUrl,
            iconImageSize: item.iconSize,
            iconImageOffset: item.offset ? item.offset : [0, -50],
        });
    }





}
